import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IEmailField, MultiFieldData } from '@shared/interfaces';

@Component({
  selector: 'app-section-email',
  templateUrl: './section-email.component.html',
  styleUrls: ['./section-email.component.scss'],
  standalone: false,
})
export class SectionEmailComponent {
  @Input() sectionName: IEmailField;
  @Input() value: any; // ✅ receive customer_name value from parent
  @Output() setValue = new EventEmitter<any>();

  onComplexFieldSetClicked(_form: MultiFieldData) {
    this.setValue.emit(_form.value); // ✅ emit only value
  }
}
